export const pageStatus = () => {
  const rootElem = document.querySelector("#root");

  if (rootElem) {
    return parseInt(rootElem.getAttribute("data-error-code"));
  }

  return;
};

export const isErrorPage = () => {
  const status = pageStatus();

  return status >= 400 && status < 600;
};
